import { CustomComponentProps } from "utils/types/generalTypes";
import SVG, { SVGSizes } from "./SVG";

export type ButtonColors =
    | "primary-button"
    | "accent-button"
    | "green-button"
    | "blue-button"
    | "red-button"
    | "grey-button"
    | "dark-grey-button";

export type ButtonTypes = "is-reversed-phantom" | "is-phantom" | "is-solid";

export type ButtonProps = CustomComponentProps & {
    text: string;
    handleClick?: Function;
    svg?: string | boolean;
    svgSize?: SVGSizes;
    type?: ButtonTypes;
    rounded?: boolean;
    loading?: boolean;
    raised?: boolean;
    disabled?: boolean;
    color?: ButtonColors | "";
};

const Button = ({
    text,
    handleClick,
    svg = false,
    svgSize = 16,
    type = "is-solid",
    rounded = false,
    loading = false,
    raised = true,
    disabled = false,
    color = "primary-button",
    className,
    style
}: ButtonProps) => {
    return (
        <button
            className={`button d-flex flex-j-center flex-a-center gap-10 ${type} ${color} ${
                loading ? "is-loading" : ""
            } ${raised ? "is-raised" : ""} ${disabled ? "is-disabled" : ""} ${
                rounded ? "is-rounded" : ""
            } ${className}`}
            style={style}
            onClick={() => handleClick && (handleClick as Function)()}
        >
            {svg ? <SVG svg="svg" size={svgSize} /> : ""}
            <span>{text}</span>
        </button>
    );
};

export default Button;
